import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

import { ButtonCloseDialogComponent } from '../button-close-dialog/button-close-dialog.component';
import { ButtonAddComponent } from '../button-add/button-add.component';
import { ButtonCancelDialogComponent } from '../button-cancel-dialog/button-cancel-dialog.component';
import { A11yModule } from '@angular/cdk/a11y';

import { MatExpansionModule } from '@angular/material/expansion';
import { ButtonSaveComponent } from '../button-save/button-save.component';
import { ButtonCloseComponent } from '../button-close/button-close.component';
import { AccionesDialog } from '@models/base/identificadores.model';
import { ButtonDeleteAndCancelComponent } from '../button-delete-and-cancel/button-delete-and-cancel.component';
import { CreateKeyValueRequest } from '@models/base/createKeyValueRequest.model';
import { UpdateKeyValueRequest } from '@models/base/updateKeyValueRequest.model';
import { BaseDto } from '@models/base/baseDto.model';

@Component({
    selector: 'app-dialog-form',
    imports: [MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatDialogModule, ButtonCloseDialogComponent, A11yModule, MatExpansionModule, ButtonSaveComponent, ButtonDeleteAndCancelComponent, ButtonCloseComponent,
        // Faltaban los dos: el template los usaba igual y CUSTOM_ELEMENTS_SCHEMA tapaba el
        // error, así que <app-button-add> se dibujaba como un elemento desconocido —  sin
        // componente detrás y sin (addClicked). Por eso "Nuevo" abría el diálogo pero el botón
        // Agregar no hacía absolutamente nada.
        ButtonAddComponent, ButtonCancelDialogComponent],
    templateUrl: './dialog-form.component.html',
    styleUrl: './dialog-form.component.css',
    //changeDetection: ChangeDetectionStrategy.OnPush,
    // Se saca CUSTOM_ELEMENTS_SCHEMA a propósito: estaba silenciando los dos componentes sin
    // importar. Sin él, olvidarse un import vuelve a ser un error de compilación en vez de un
    // botón mudo que nadie sabe por qué no anda.
})
export class DialogFormComponent {
  dialogRef = inject<MatDialogRef<DialogFormComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);
  private fb = inject(FormBuilder);

  form: FormGroup;
  localData: any;
  get f() { return this.form.controls; }
  constructor() {

    this.form = this.fb.group({
      Descripcion: [this.data?.item?.descripcion || '', Validators.compose([Validators.required, Validators.maxLength(100)])],
      Observaciones: [this.data?.item?.observaciones || '',Validators.compose([ Validators.maxLength(200)])]
    });
  }

  /**
   * Devolvía `this.data.item`, que en el alta es el objeto vacío {} que manda generic-table:
   * lo que el usuario escribía en el formulario NUNCA viajaba. En el alta el backend recibía
   * un registro sin descripción, y en la edición se reenviaban los valores originales, así que
   * modificar parecía funcionar y no guardaba nada.
   */
  agregar() {
    if (this.form.invalid) { this.form.markAllAsTouched(); return; }

    this.dialogRef.close({
      event: AccionesDialog.Agregar,
      data: new CreateKeyValueRequest(this.descripcion(), this.observaciones())
    });
  }

  modificar() {
    if (this.form.invalid) { this.form.markAllAsTouched(); return; }

    const request = new UpdateKeyValueRequest();
    request.id = this.data?.item?.id;
    request.descripcion = this.descripcion();
    request.observaciones = this.observaciones();
    // El proyecto tiene optimistic locking en todas las entidades: reenviar el RowVersion que
    // vino en la lectura activa el chequeo de concurrencia en vez de dejarlo inerte.
    request.rowVersion = this.data?.item?.rowVersion;

    this.dialogRef.close({ event: AccionesDialog.Modificar, data: request });
  }

  /** El input fuerza mayúsculas por CSS, que es solo visual: el valor se normaliza acá. */
  private descripcion(): string {
    return (this.form.value.Descripcion || '').trim().toUpperCase();
  }

  private observaciones(): string {
    return (this.form.value.Observaciones || '').trim();
  }

  eliminar(){
    this.dialogRef.close({event:AccionesDialog.Eliminar, data: this.data.item as BaseDto});
  }

  cancelar() {
    this.dialogRef.close({event:AccionesDialog.Cancelar, data: this.data});
  }
}
